import { ArrowLeft, Wand2 } from "lucide-react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

interface EnhanceButtonProps {
  isEnhanced: boolean;
  isEnhancing: boolean;
  onEnhanceClick: () => void;
  disabled?: boolean;
}

export const EnhanceButton = ({
  isEnhanced,
  isEnhancing,
  onEnhanceClick,
  disabled = false,
}: EnhanceButtonProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className="flex items-center gap-2 text-sm bg-white/90 dark:bg-gray-800/90 backdrop-blur-xl rounded-2xl px-4 py-2.5 shadow-lg cursor-pointer border border-white/40 dark:border-gray-700/40"
      onClick={disabled ? undefined : onEnhanceClick}
      whileHover={
        !disabled
          ? {
              scale: 1.05,
              boxShadow: "0 10px 30px rgba(147,51,234,0.2)",
              transition: { duration: 0.2 },
            }
          : undefined
      }
      whileTap={!disabled ? { scale: 0.95 } : undefined}
      style={{
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {isEnhanced ? (
        <>
          <motion.div
            animate={{ x: [-2, 2, -2] }}
            transition={{
              duration: 1,
              repeat: Infinity,
            }}
          >
            <ArrowLeft
              className={`w-4 h-4 text-purple-600 dark:text-purple-400 ${isEnhancing ? "animate-spin" : ""}`}
            />
          </motion.div>
          <span className="font-medium text-purple-600 dark:text-purple-400">
            {t("imagen.backToOriginal")}
          </span>
        </>
      ) : (
        <>
          <motion.div
            animate={
              !isEnhancing
                ? {
                    rotate: [0, 10, -10, 0],
                    scale: [1, 1.1, 1],
                  }
                : { rotate: 360 }
            }
            transition={
              !isEnhancing
                ? {
                    duration: 2,
                    repeat: Infinity,
                  }
                : {
                    duration: 0.5,
                    repeat: Infinity,
                    ease: "linear",
                  }
            }
          >
            <Wand2 className="w-4 h-4 text-purple-600 dark:text-purple-400" />
          </motion.div>
          <span className="font-medium text-purple-600 dark:text-purple-400">
            {t("imagen.enhance")}
          </span>
        </>
      )}
    </motion.div>
  );
};

export default EnhanceButton;
